<form [formGroup]="file_image_form">
    <div class="form-group">
        <div class="input-group input-group-sm file-upload">
            
            <input type="file" [imageToDataUrl]="options" formControlName="image_picker"
            (imageSelected)="selected($event)" accept=".pdf, .jpg, .jpeg, .png, .gif, .tiff, .docx, .doc, .rtf" class="file-upload-btn">
            
            <input type="text" class="form-control form-control-sm" placeholder="Choose a file..." formControlName="file_name">
            
            <i class="fa fa-times delete-file" (click)="removeFile()" *ngIf="src!==null"></i>
            
            <span class="input-group-append">
                <button class="btn btn-primary" type="button"><i class="fa fa-upload"></i></button>
            </span>
        </div>
    </div>
    
</form>
